export enum OrgSubmitMode {
    Single = 'single',
    SinglePerSubmitter = 'single-per-submitter',
    Multiple = 'multiple'
}
